import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Disclaimer(_ref) {
  var disclaimer = _ref.disclaimer,
    config = _ref.config;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col",
    children: [/*#__PURE__*/_jsx("p", {
      className: " ".concat((config === null || config === void 0 ? void 0 : config.fontTitle) || "", " z-10 text-xl ").concat(config !== null && config !== void 0 && config.darkMode ? "text-primary" : "text-[#130E2F]", " mt-8 font-bold"),
      children: "Disclaimer"
    }), /*#__PURE__*/_jsx("p", {
      className: "z-10 scrollbar-thin ".concat(config !== null && config !== void 0 && config.darkMode ? "text-base-content" : "text-[#130E2F]", " mt-2 mb-8 ").concat((config === null || config === void 0 ? void 0 : config.fontBody) || ""),
      children: disclaimer
    })]
  });
}
export default Disclaimer;